/**! common js file on all pages */
import Cookies from '../plugins/js.cookie.js';
import StickySidebar from '../plugins/sticky-sidebar.js';
import '../plugins/equal.js';
// import mixitup from '../plugins/jquery.mixitup.js';
// import mixitupPagination from '../plugins/jquery.mixitup-pagination.js';
import '../plugins/images.loaded.min.js';
// import '../plugins/masonry.min.js';

// mixitup.use(mixitupPagination);

export default {
    init() {
        console.log('common loaded');
        ////////////////////////////////////////////////////////////////////////////
        // JavaScript to be fired on all pages
        ////////////////////////////////////////////////////////////////////////////

        // Helper functions
        $('html').removeClass('no-js').addClass('js');

        // COMMENT OUT THESE TO TURN OFF SCROLLING TRANSITIONS AND MIXITUP
        // $('html:not(.ie9)').addClass('scroll-transitions-active');
        // if ($('body.page-template-our-work').length) {
        //     $('html').addClass('mix-it-up-active');
        // }

        var windowWidth;
        windowWidth = function () {
            if ($(window).width() >= 768 && $('html').hasClass('mobile')) {
                $('html').removeClass('mobile').addClass('desktop').trigger('htmlClassChangeToDesktop');
            } else if ($(window).width() <= 767 && $('html').hasClass('desktop')) {
                $('html').removeClass('desktop').addClass('mobile').trigger('htmlClassChangeToMobile');
            }
        };

        $(window).resize(function () {
            windowWidth();
            if ($("[data-behaviour~='text-trim']").length) {
                trimWords();
            }
        });
        windowWidth();

        ////////////////////////////////////////////////////////////////////////////
        // Detect IE
        ////////////////////////////////////////////////////////////////////////////

        function getInternetExplorerVersion() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            var rv = -1;

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                // If Internet Explorer, return version number
                if (isNaN(parseInt(ua.substring(msie + 5, ua.indexOf('.', msie))))) {
                    //For IE 11 >
                    if (navigator.appName == 'Netscape') {
                        var ua = navigator.userAgent;
                        var re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
                        if (re.exec(ua) != null) {
                            rv = parseFloat(RegExp.$1);
                            // console.log(rv);
                        }
                    } else {
                        // console.log('other browser');
                    }
                } else {
                    //For < IE11
                    // console.log(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
                }
                return true;
            }
            return false;
        }
        let isIE = getInternetExplorerVersion();
        let isIEedge = window.navigator.userAgent.indexOf('Edge') > -1;
        // console.log('isIE or isIEedge');
        if (isIE == true || isIEedge == true) $('html').addClass('isIE');

        // Fix for lazy hidden
        // var $lazyBg = jQuery('[data-bg]');
        // $lazyBg.on('lazyshow', function () {
        //     jQuery(this).fadeTo("500", 1);
        // });

        ////////////////////////////////////////////////////////////////////////////
        // Navigation Toggle - everywhere on overlay except links
        ////////////////////////////////////////////////////////////////////////////
        $("[data-toggle='nav-toggle']").on('click', function () {
            //$("[data-target='top-bar']").toggleClass("overlay-nav__hidden");
            $('html').toggleClass('overlay-nav__hidden');
        });
        $("[data-trigger='work-mobile-filters']").on('click', function () {
            $(this).closest("[data-target='work-filters']").toggleClass('work-filters-active');
        });

        ////////////////////////////////////////////////////////////////////////////
        // Helper js to show that a filter is active at the top level
        ////////////////////////////////////////////////////////////////////////////
        var parent = '.post-list__filters__list__parent';
        var child = '.post-list__filters__list__child';

        $(child).click(function () {
            var ga_category = $(this).closest(parent).find('span').text();
            var ga_action = 'filtered';
            var ga_label = $(this).text();

            console.log(ga_category);

            // ga('send', 'event', ga_category, ga_action, ga_label);
            // gtag('event', ga_action, {
            //     event_category: ga_category,
            //     event_label: ga_label,
            // });
            $(parent).removeClass('active');
            $(this).closest(parent).addClass('active');
        });

        ////////////////////////////////////////////////////////////////////////////
        // AUTO PLAY HTML VIDEO WHEN IN VIEW
        ////////////////////////////////////////////////////////////////////////////

        // Get media - with autoplay disabled (audio or video)
        var media = $('video').not("[autoplay='autoplay']");
        var tolerancePixelTop = 0;
        var tolerancePixelBottom = 400;

        function checkMedia() {
            // Get current browser top and bottom
            var scrollTop = $(window).scrollTop() + tolerancePixelTop;
            var scrollBottom = $(window).scrollTop() + $(window).height() - tolerancePixelBottom;

            media.each(function () {
                var yTopMedia = $(this).offset().top;
                var yBottomMedia = $(this).height() + yTopMedia;

                if (scrollTop < yBottomMedia && scrollBottom > yTopMedia) {
                    //view explaination in `In brief` section above
                    $(this).get(0).play();
                } else {
                    $(this).get(0).pause();
                }
            });
        }

        $(document).on('scroll', checkMedia);

        ////////////////////////////////////////////////////////////////////////////
        // Add Asterisk to required form fields
        ////////////////////////////////////////////////////////////////////////////
        $('.form-control[required]').before("<span class='asterisk'>*</span>");

        ////////////////////////////////////////////////////////////////////////////
        // Trim post title if on mobile...
        ////////////////////////////////////////////////////////////////////////////

        function trimWords() {
            //change number of words depending on width in the category blog page
            var maxLength = 99999;
            var suffix = '';
            var trimmedString;
            var contentWidth = $(document).width(); //get width of browser
            if (contentWidth < 479) {
                maxLength = 20; // maximum number of characters to extract
                suffix = '...';
            } else if (contentWidth > 480 && contentWidth < 767) {
                maxLength = 35; // maximum number of characters to extract
                suffix = '...';
            }
            //trim the string to the maximum length
            trimmedString = theString.substr(0, maxLength);
            //re-trim if we are in the middle of a word
            //trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
            $(trimSelector).html(trimmedString + suffix);
        }

        if ($("[data-behaviour~='text-trim']").length) {
            var trimSelector = "[data-behaviour~='text-trim']";
            var theString = $(trimSelector).html(); //the string
            trimWords();
        }

        ////////////////////////////////////////////////////////////////////////////
        // DETECT DISTANCE FROM BOTTOM TO HIDE DOWN ARROW
        ////////////////////////////////////////////////////////////////////////////
        $(document).on('scroll', function () {
            var arrowClass = 'post-arrow-bottom';
            var distanceFromBottom = Math.floor($(document).height() - $(document).scrollTop() - $(window).height());
            if (distanceFromBottom < 200) {
                $('body').addClass(arrowClass);
            } else {
                $('body').removeClass(arrowClass);
            }
        });

        ////////////////////////////////////////////////////////////////////////////
        // NEWS PAGE MASONRY AND VIDEO LOADED
        ////////////////////////////////////////////////////////////////////////////

        let newsGrid = $('.news-wrapper');

        let newsCurrentPage = 1;
        $('.load-more-news').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('loading')) return;
            let loadMoreButton = $(this);
            let dataShow = $(this).attr('data-show');
            let dataPages = $(this).attr('data-pages');

            $.ajax({
                url: nk_ajax_vars.ajaxurl,
                type: 'post',
                // dataType: 'json',
                data: {
                    action: 'nk_ajax_news',
                    security: nk_ajax_vars.nkNonce,
                    dataPaged: newsCurrentPage + 1,
                    dataShow: dataShow,
                },
                beforeSend: function () {
                    loadMoreButton.addClass('loading');
                },
                success: function (data) {
                    let elements = $(data).find('.masonry-item');

                    newsGrid.append(elements.prevObject);
                    // .imagesLoaded(function () {
                    //     newsGrid.masonry('appended', elements.prevObject);
                    // });

                    loadMoreButton.removeClass('loading');

                    newsCurrentPage++;
                    if (newsCurrentPage >= dataPages) loadMoreButton.remove();
                },
                error: function (responce) {
                    // console.log('failed: ' + responce);
                },
            });
        });

        /*-------------------------------------------------------------------------*/
        //
        // INFO: Filter Work / News
        //
        /*-------------------------------------------------------------------------*/
        $('.filter-item').on('click', function (e) {
            e.preventDefault();
            const pageCurrent = $(this).closest('.filters-work-top').data('pagecurrent');
            const queryParam = $(this).data('query-param') || 'show';
            if ($(this).hasClass('active-child')) {
                $(this).removeClass('active-child');
            } else {
                $(this)
                    .closest('.filter-sub')
                    .find('.filter-item')
                    .removeClass('active-child');
                $(this).addClass('active-child');
            }
            let params = new URLSearchParams();
            $('.filters-work-top .filter-item.active-child').each(function () {
                const itemParam = $(this).data('query-param') || 'show';
                const itemFilter = $(this).data('filter');
                if (itemFilter) {
                    if (params.has(itemParam)) {
                        const currentValue = params.get(itemParam);
                        params.set(itemParam, `${currentValue},${itemFilter}`);
                    } else {
                        params.set(itemParam, itemFilter);
                    }
                }
            });
            let newURL = `${window.location.origin}/${pageCurrent}/`;
            const queryString = params.toString();
            if (queryString !== '') {
                newURL = `${newURL}?${queryString}`;
            }
            window.location.assign(newURL);
        });

        /*-------------------------------------------------------------------------*/
        //
        // INFO: Load more work
        //
        /*-------------------------------------------------------------------------*/

        $('.load-more-work').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('loading')) return;
            let loadMoreButton = $(this);
            let currentPage = loadMoreButton.attr('attr-current-page');
            const maxPage = loadMoreButton.attr('attr-max-page');
            const filter = loadMoreButton.attr('attr-filter');
            const service = loadMoreButton.attr('attr-service');
            $.ajax({
                url: nk_ajax_vars.ajaxurl,
                type: 'post',
                dataType: 'json',
                data: {
                    action: 'nk_ajax_work',
                    security: nk_ajax_vars.nkNonce,
                    currentPage: currentPage,
                    maxPage: maxPage,
                    filter: filter,
                    service: service,
                },
                beforeSend: function () {
                    loadMoreButton.addClass('loading');
                },
                success: function (data) {
                    const appendedItems = $(data.content);
                    loadMoreButton.removeClass('loading');
                    $('.post-list').append(appendedItems);

                    let pendingMedia = 0;
                    let resizeTriggered = false;
                    const triggerResize = function () {
                        if (resizeTriggered) return;
                        resizeTriggered = true;
                        $(window).trigger('resize');
                    };

                    appendedItems.find('img, video').each(function () {
                        pendingMedia++;
                        $(this).one('load loadeddata error', function () {
                            pendingMedia--;
                            if (pendingMedia <= 0) {
                                triggerResize();
                            }
                        });

                        if (this.complete || (this.readyState && this.readyState >= 2)) {
                            pendingMedia--;
                        }
                    });

                    if (pendingMedia <= 0) {
                        triggerResize();
                    } else {
                        setTimeout(triggerResize, 800);
                    }

                    currentPage++;
                    loadMoreButton.attr('attr-current-page', currentPage);
                    if (currentPage >= maxPage) loadMoreButton.remove();
                },
                error: function (responce) {
                    // console.log('failed: ' + responce);
                },
            });
        });

        //--------------------------------------------------------------------------
        //
        //  !Popup functionality
        //
        //-------------------------------------------------------------------------*/
        let body = $('body');
        function popupCreate() {
            let overly = $('.overly');
            body.trigger('popupCreateBefore');

            body.addClass('pop-on');
            $('html').addClass('pop-on');
            overly.fadeIn().addClass('visible');
            body.trigger('popupCreateFinished');
        }

        function popupClose() {
            $('.overly')
                .removeClass('visible')
                .fadeOut(function () {
                    // $(this).remove();
                });
            body.removeClass('pop-on');
            $('html').removeClass('pop-on');
        }

        $('.btn-footer-subscribe').on('click', function (e) {
            e.preventDefault();
            popupCreate();
        });

        // checkbox
        $('.wpcf7-checkbox').on('click', '.wpcf7-list-item-label', function () {
            $(this).closest('.wpcf7-checkbox').find('input').trigger('click');
        });

        // Detect clicks outside of elements
        // need separate events fired on diferent elements
        body.on('click', '.overly', function (e) {
            if (e.target !== this) return; // prevent children from fireing event
            popupClose();
        });
        body.on('click', '.popup-close', function (e) {
            e.preventDefault();
            popupClose();
        });

        body.on('keyup', function (key) {
            if (key.keyCode == 27) {
                popupClose();
            }
        });

        // Open popup if param in
        var urlParams = new URLSearchParams(window.location.search); //get all parameters
        var subscribe = urlParams.get('subscribe');

        if (subscribe) {
            //check if foo parameter is set to anything
            console.log(subscribe);
            $('.popup form .referal').val(subscribe);
            popupCreate();
        }

        // Close popup 1 second after submission
        document.addEventListener(
            'wpcf7mailsent',
            function (event) {
                setTimeout(function () {
                    popupClose();
                }, 1500);
            },
            false
        );

        //--------------------------------------------------------------------------
        //
        //  !Cookie info
        //
        //-------------------------------------------------------------------------*/
        let closeCookies = () => {
            $('.cookie-info').fadeOut(() => $('.cookie-info').remove());
        };
        $('.cookie-agree').on('click', function (e) {
            e.preventDefault();
            Cookies.set('wpa-cookie-policy', 'true', { expires: 90 });
            closeCookies();
        });

        $('.cookie-close').on('click', function (e) {
            e.preventDefault();
            closeCookies();
        });

        //--------------------------------------------------------------------------
        //
        //  !Magnet functionality
        //
        //-------------------------------------------------------------------------*/

        let insightsBox = $('.insights-box');
        function openInsights() {
            if (insightsBox.hasClass('in-opened')) return;
            insightsBox.addClass('in-opened');
        }

        function closeInsights() {
            if (!insightsBox.hasClass('in-opened')) return;
            insightsBox.removeClass('in-opened');
        }

        $(insightsBox).on('click', 'h3', function () {
            if (isIE == true || isIEedge == true) {
                const redirectIfIe = insightsBox.find('a').attr('href');
                // console.log(redirectIfIe);
                window.location.href = redirectIfIe;
            } else {
                openInsights();
            }
        });

        $(insightsBox).on('click', '.in-hide', function () {
            closeInsights();
        });

        let showDownloadLink = () => {
            let magnetWrap = $('.magnet-form');
            let contactForm = magnetWrap.find('.wpcf7');
            if (!contactForm) return;
            if ($(window).width() >= 768) {
                let magnetRowHeight = $('.magnet-form');
                magnetRowHeight.find('.magnet-image-wrap').css('height', magnetRowHeight.outerHeight());
            }
            contactForm.on('wpcf7mailsent', () => {
                let link = magnetWrap.find('.magnet-download').attr('data-attr');
                magnetWrap.find('.magnet-download a').prop('href', link);
                contactForm.slideUp(() => {
                    magnetWrap.find('.magnet-download').slideDown();
                });

                insightsBox.animate(
                    {
                        bottom: '-350',
                    },
                    500,
                    function () {
                        insightsBox.remove();
                    }
                );

                Cookies.set('wpa-magnet', 'true');
            });
        };
        showDownloadLink();

        $('.studies-sections .block-text').matchHeight();
    },
    finalize() {},
};
